import { scrollTop, onScroll } from '../utils/scroll';
import { currentBreakpoint } from '../utils/windowResize';
import { navWidth } from './nav';

export let windowWidth;
export let windowHeight;

export function setupImageToVideo() {
    windowWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    windowHeight = window.innerHeight;

    if (currentBreakpoint != 'xxs' && currentBreakpoint != 'xs') {
        const imageToVideos = document.querySelectorAll('.image-and-text--image-to-video');
        const images = document.querySelectorAll('.image-and-text--image-to-video .image-and-text__image-wrap__inner');
        const allImages = document.querySelectorAll('img');
        let loadedImages = 0;
        let notLoadedImages = 0;

        function initImageToVideo() {
            onScroll(() => {
                for (let a = 0, l = images.length; a < l; a++) {
                    const image = images[a];
                    const imageToVideo = image.closest('.image-and-text--image-to-video');
                    const videoIframe = -1;

                    if (imageToVideo != undefined) {
                        const video = imageToVideos[a].nextElementSibling;
                        const isNextVideo = !!video.classList.contains('media');

                        if (isNextVideo && image.hasAttribute('data-top')) {
                            const imageHeight = image.getAttribute('data-height');
                            const imageCenterY = (windowHeight - imageHeight) / 2;
                            const videoTop = parseInt(video.getAttribute('data-top'));
                            const addWidthPrPx = image.getAttribute('data-add-width-pr-px');
                            const addHeightPrPx = image.getAttribute('data-add-height-pr-px');
                            const translateYPrPx = image.getAttribute('data-translate-y-pr-px');
                            const translateXPrPx = image.getAttribute('data-translate-x-pr-px');
                            const imageFixedTop = image.getAttribute('data-image-fixed-top');
                            const imageFixedLeft = image.getAttribute('data-image-fixed-left');
                            const addWidth = (scrollTop - (videoTop - windowHeight)) * addWidthPrPx;
                            const addHeight = (scrollTop - (videoTop - windowHeight)) * addHeightPrPx;
                            let translateY = (scrollTop - (videoTop - windowHeight)) * translateYPrPx;
                            let translateX = (scrollTop - (videoTop - windowHeight)) * translateXPrPx;
                            let newWidth = parseInt(image.getAttribute('data-width')) + addWidth;
                            let newHeight = parseInt(image.getAttribute('data-height')) + addHeight;
                            const imageMaxWidth = parseInt(image.getAttribute('data-max-width'));
                            const imageMaxHeight = parseInt(image.getAttribute('data-max-height'));
                            const translateYMax = image.getAttribute('data-translate-y-max');
                            const translateXMax = image.getAttribute('data-translate-x-max');

                            newWidth = newWidth > imageMaxWidth ? imageMaxWidth : newWidth;
                            newHeight = newHeight > imageMaxHeight ? imageMaxHeight : newHeight;
                            translateY = translateY < translateYMax ? translateYMax : translateY;
                            translateX = translateX < translateXMax ? translateXMax : translateX;

                            const imageNode = image.querySelector('img');
                            const imageNodeMarginLeft = getComputedStyle(imageNode).marginLeft.replace('px','');
                            const nodeTranslateXPrPx = imageNode.getAttribute('data-translate-x-pr-px');
                            let nodeTranslateX = (scrollTop - (videoTop - windowHeight)) * nodeTranslateXPrPx;

                            if (nodeTranslateX > (imageNodeMarginLeft * -1)) {
                                nodeTranslateX = nodeTranslateX * -1;
                            }

                            videoIframe = video.querySelector('iframe');
                            const player = new Vimeo.Player(videoIframe);

                            function setAbsolute() {
                                image.style.width = `${imageMaxWidth}px`;
                                image.style.height = `${imageMaxHeight}px`;
                                image.style.position = 'absolute';
                                image.style.top = '100%';
                                image.style.left = '0';
                                image.style.zIndex = '1000';
                                image.style.transform = null;
                                image.style.opacity = '0';

                                imageNode.style.transform = `translate3d(${imageNodeMarginLeft * - 1}px,0,0)`;

                                video.style.opacity = 1;

                                player.play();
                            }

                            function setFixed() {
                                image.style.width = `${newWidth}px`;
                                image.style.height = `${newHeight}px`;
                                image.style.position = 'fixed';
                                image.style.top = `${imageFixedTop}px`;
                                image.style.left = `${imageFixedLeft}px`;
                                image.style.zIndex = '1000';
                                //image.style.transform = `translate3d(${translateX}px,${translateY}px,0)`;
                                image.style.transform = `translate3d(${translateX}px,0,0)`;
                                image.style.opacity = null;

                                imageNode.style.transform = `translate3d(${nodeTranslateX}px,0,0)`;

                                video.style.opacity = null;

                                player.pause();
                            }

                            function removeFixed() {
                                image.style.width = null;
                                image.style.height = null;
                                image.style.position = null;
                                image.style.top = null;
                                image.style.left = null;
                                image.style.zIndex = null;
                                image.style.transform = null;
                                image.style.opacity = null;

                                imageNode.style.transform = null;

                                video.style.opacity = null;

                                player.pause();
                            }

                            if (scrollTop >= (videoTop - windowHeight) && (scrollTop < videoTop - imageFixedTop)) {
                                setFixed();
                            } else if (scrollTop < (videoTop - windowHeight)) {
                                removeFixed();
                            } else if (scrollTop >= (videoTop - imageFixedTop)) {
                                setAbsolute();
                            }
                        }
                    }
                }
            });

            for (let a = 0, l = imageToVideos.length; a < l; a++) {
                const image = imageToVideos[a].querySelector('.image-and-text__image-wrap__inner');

                if (image != undefined) {
                    const video = imageToVideos[a].nextElementSibling;
                    const isNextVideo = !!video.classList.contains('media');

                    if (isNextVideo) {
                        /*const height = parseFloat(getComputedStyle(imageToVideos[a], null).height.replace('px', ''));
                        imageToVideos[a].style.height = `${height}px`;*/

                        // RP, 09-03-2020
                        // We need to add 16/9 height of windowwiidth - 95px (nav) to the element and set margin-top on video to minus this value
                        // We need this because we want text to be sticky down to the video....

                        const testHeight = parseFloat(getComputedStyle(imageToVideos[a], null).height.replace('px', '')) + ((windowWidth - navWidth) * 0.5625);
                        imageToVideos[a].style.height = `${testHeight}px`;

                        const videoMarginTop = ((windowWidth - navWidth) * 0.5625) * -1;
                        video.style.marginTop = `${videoMarginTop}px`;

                        const imageTop = image.getBoundingClientRect().top + scrollTop;
                        const imageFixedTop = windowHeight - (video.getBoundingClientRect().top - image.getBoundingClientRect().top);
                        const videoTop = video.getBoundingClientRect().top + scrollTop;
                        const imageFixedLeft = image.getBoundingClientRect().left;
                        const imageWidth = image.offsetWidth;
                        const imageHeight = image.offsetHeight;
                        const videoWidth = video.offsetWidth;
                        const videoHeight = video.offsetHeight;
                        const widthDiff = videoWidth - imageWidth;
                        const heightDiff = videoHeight - imageHeight;

                        const imageCenterY = (windowHeight - imageHeight) / 2;

                        const addWidthPrPx = widthDiff / (videoTop - imageTop);
                        const addHeightPrPx = heightDiff / (videoTop - imageTop);
                        const translateX = (image.getBoundingClientRect().left - video.getBoundingClientRect().left);
                        //const translateYPrPx = (imageFixedTop / (videoTop - (imageTop))) * -1;
                        const translateYPrPx = (imageCenterY / (videoTop - (imageTop - imageFixedTop)) * -1);
                        const translateXPrPx = (translateX / (videoTop - (imageTop))) * -1;

                        video.setAttribute('data-top', videoTop);
                        image.setAttribute('data-top', imageTop);
                        image.setAttribute('data-width', imageWidth);
                        image.setAttribute('data-height', imageHeight);
                        image.setAttribute('data-max-width', videoWidth);
                        image.setAttribute('data-max-height', videoHeight);
                        image.setAttribute('data-add-width-pr-px',addWidthPrPx);
                        image.setAttribute('data-add-height-pr-px', addHeightPrPx);
                        image.setAttribute('data-image-fixed-top', imageFixedTop);
                        image.setAttribute('data-image-fixed-left', imageFixedLeft);
                        image.setAttribute('data-translate-x-pr-px', translateXPrPx);
                        image.setAttribute('data-translate-y-pr-px', translateYPrPx);
                        image.setAttribute('data-translate-y-max', parseInt(imageFixedTop * -1));
                        image.setAttribute('data-translate-x-max', (translateX * -1));

                        const imageNode = image.querySelector('img');
                        const imageNodeMarginLeft = getComputedStyle(imageNode).marginLeft.replace('px','');
                        const nodeTranslateXPrPx = ((imageNodeMarginLeft * -1) / (videoTop - (imageTop)));

                        imageNode.setAttribute('data-translate-x-pr-px',nodeTranslateXPrPx);
                    }
                }
            }
        }

        if (imageToVideos.length > 0) {
            for (let a = 0, l = allImages.length; a < l; a++) {
                const image = allImages[a];

                function imageLoaded() {
                    loadedImages++;
                }

                function imageNotLoaded() {
                    notLoadedImages++;
                }

                if (image.complete) {
                    loadedImages++;
                } else {
                    image.addEventListener('load', imageLoaded);
                    image.addEventListener('error', imageNotLoaded);
                }
            }

            const checkImagesAndVimeoAPI = setInterval(function () {
                if (loadedImages + notLoadedImages == allImages.length && Vimeo != undefined) {
                    clearInterval(checkImagesAndVimeoAPI);
                    initImageToVideo();
                }
            }, 100);
        }
    }
}